import { render, staticRenderFns } from "./UsersMain.vue?vue&type=template&id=4a8fb070&scoped=true"
import script from "./UsersMain.vue?vue&type=script&lang=js"
export * from "./UsersMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8fb070",
  null
  
)

export default component.exports